// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { PlanBasedBidsTableV2_BidContractRevisionFragmentDoc, PlanBasedBidsTableV2_BidPackageFragmentDoc } from './components/PlanBasedBidsTableV2.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EnterPlanBasedBidPageQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
  tradePartnerId: Types.Scalars['ID']['input'];
}>;


export type EnterPlanBasedBidPageQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus }, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, activeRequests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined } }> }, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string } }> }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type EnterPlanBasedBidPage_BidPackageFragment = { __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus }, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, activeRequests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined } }> }, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string } }> };

export type EnterPlanBasedBidPage_SaveBidContractMutationVariables = Types.Exact<{
  input: Types.SaveBidContractInput;
}>;


export type EnterPlanBasedBidPage_SaveBidContractMutation = { __typename?: 'Mutation', saveBidContract: { __typename?: 'SaveBidContractResult', bidContract: { __typename?: 'BidContract', id: string, currentRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined } } } } };

export const EnterPlanBasedBidPage_BidPackageFragmentDoc = gql`
    fragment EnterPlanBasedBidPage_BidPackage on BidPackage {
  ...PlanBasedBidsTableV2_BidPackage
  bidPackageGroup {
    id
  }
}
    ${PlanBasedBidsTableV2_BidPackageFragmentDoc}`;
export const EnterPlanBasedBidPageDocument = gql`
    query EnterPlanBasedBidPage($bidPackageId: ID!, $tradePartnerId: ID!) {
  bidPackage(id: $bidPackageId) {
    ...EnterPlanBasedBidPage_BidPackage
  }
  tradePartner(id: $tradePartnerId) {
    ...Named
  }
}
    ${EnterPlanBasedBidPage_BidPackageFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useEnterPlanBasedBidPageQuery__
 *
 * To run a query within a React component, call `useEnterPlanBasedBidPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterPlanBasedBidPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterPlanBasedBidPageQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *      tradePartnerId: // value for 'tradePartnerId'
 *   },
 * });
 */
export function useEnterPlanBasedBidPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables> & ({ variables: EnterPlanBasedBidPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>(EnterPlanBasedBidPageDocument, options);
      }
export function useEnterPlanBasedBidPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>(EnterPlanBasedBidPageDocument, options);
        }
// @ts-ignore
export function useEnterPlanBasedBidPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>;
export function useEnterPlanBasedBidPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterPlanBasedBidPageQuery | undefined, EnterPlanBasedBidPageQueryVariables>;
export function useEnterPlanBasedBidPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>(EnterPlanBasedBidPageDocument, options);
        }
export type EnterPlanBasedBidPageQueryHookResult = ReturnType<typeof useEnterPlanBasedBidPageQuery>;
export type EnterPlanBasedBidPageLazyQueryHookResult = ReturnType<typeof useEnterPlanBasedBidPageLazyQuery>;
export type EnterPlanBasedBidPageSuspenseQueryHookResult = ReturnType<typeof useEnterPlanBasedBidPageSuspenseQuery>;
export type EnterPlanBasedBidPageQueryResult = Apollo.QueryResult<EnterPlanBasedBidPageQuery, EnterPlanBasedBidPageQueryVariables>;
export const EnterPlanBasedBidPage_SaveBidContractDocument = gql`
    mutation EnterPlanBasedBidPage_SaveBidContract($input: SaveBidContractInput!) {
  saveBidContract(input: $input) {
    bidContract {
      id
      currentRevision {
        ...PlanBasedBidsTableV2_BidContractRevision
      }
    }
  }
}
    ${PlanBasedBidsTableV2_BidContractRevisionFragmentDoc}`;
export type EnterPlanBasedBidPage_SaveBidContractMutationFn = Apollo.MutationFunction<EnterPlanBasedBidPage_SaveBidContractMutation, EnterPlanBasedBidPage_SaveBidContractMutationVariables>;

/**
 * __useEnterPlanBasedBidPage_SaveBidContractMutation__
 *
 * To run a mutation, you first call `useEnterPlanBasedBidPage_SaveBidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterPlanBasedBidPage_SaveBidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterPlanBasedBidPageSaveBidContractMutation, { data, loading, error }] = useEnterPlanBasedBidPage_SaveBidContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnterPlanBasedBidPage_SaveBidContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnterPlanBasedBidPage_SaveBidContractMutation, EnterPlanBasedBidPage_SaveBidContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnterPlanBasedBidPage_SaveBidContractMutation, EnterPlanBasedBidPage_SaveBidContractMutationVariables>(EnterPlanBasedBidPage_SaveBidContractDocument, options);
      }
export type EnterPlanBasedBidPage_SaveBidContractMutationHookResult = ReturnType<typeof useEnterPlanBasedBidPage_SaveBidContractMutation>;
export type EnterPlanBasedBidPage_SaveBidContractMutationResult = Apollo.MutationResult<EnterPlanBasedBidPage_SaveBidContractMutation>;
export type EnterPlanBasedBidPage_SaveBidContractMutationOptions = Apollo.BaseMutationOptions<EnterPlanBasedBidPage_SaveBidContractMutation, EnterPlanBasedBidPage_SaveBidContractMutationVariables>;